/**
 * Run `handler` when the tab becomes visible again, debounced to avoid
 * refetch storms when switching back from another tab.
 */
export function onTabVisibleRefresh(handler: () => void, debounceMs = 400): () => void {
  let timer: ReturnType<typeof setTimeout> | null = null;

  const onVisible = () => {
    if (document.visibilityState !== 'visible') return;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      handler();
    }, debounceMs);
  };

  document.addEventListener('visibilitychange', onVisible);
  return () => {
    if (timer) clearTimeout(timer);
    document.removeEventListener('visibilitychange', onVisible);
  };
}
